import { supabase } from '../lib/supabase.js';

const listeners = new Set();
const activeJobs = new Map();
const SUPPORTED = new Set(['myto-cz']);

function emit(message) {
  listeners.forEach(listener => {
    try {
      listener(message);
    } catch (error) {
      console.error('[D24 BROWSERLESS] Błąd listenera:', error);
    }
  });
}

async function requireSession() {
  if (!supabase) throw new Error('Brak połączenia z Supabase.');
  const { data, error } = await supabase.auth.getSession();
  if (error) throw new Error(`Nie udało się sprawdzić sesji: ${error.message}`);
  if (!data?.session?.access_token) throw new Error('Sesja wygasła. Zaloguj się ponownie.');
  return data.session;
}

async function functionErrorMessage(error, fallback) {
  try {
    if (error?.context && typeof error.context.json === 'function') {
      const body = await error.context.json();
      if (body?.error) return body.error;
    }
  } catch {}
  return error?.message || error?.details || error?.hint || fallback;
}

export function onBrowserlessCalculatorMessage(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export async function startBrowserlessCalculatorJob(payload) {
  await requireSession();

  const calculatorKey = String(payload?.calculatorKey || '');
  if (!SUPPORTED.has(calculatorKey)) {
    throw new Error(`Kalkulator ${calculatorKey || 'bez klucza'} nie jest obsługiwany przez Browserless.`);
  }
  if (!Array.isArray(payload?.points) || payload.points.length < 2) {
    throw new Error('Do obliczenia MYTO CZ potrzebne są co najmniej dwa punkty.');
  }
  if (payload.points.length > 5) {
    throw new Error(`MYTO CZ obsługuje maksymalnie 5 punktów. Odcinek zawiera ${payload.points.length}. Zmniejsz liczbę punktów i ponownie wyznacz trasę.`);
  }

  const jobId = String(payload.jobId || crypto.randomUUID());
  if (activeJobs.has(jobId)) return activeJobs.get(jobId);

  const normalizedPayload = {
    ...payload,
    jobId,
    requestId:jobId,
  };

  emit({
    source:'D24_BROWSERLESS_CALCULATOR',
    transport:'browserless',
    type:'JOB_ACCEPTED',
    payload:normalizedPayload,
  });

  const promise = (async () => {
    emit({
      source:'D24_BROWSERLESS_CALCULATOR',
      transport:'browserless',
      type:'JOB_STATUS',
      payload:{ ...normalizedPayload, status:'processing' },
    });

    const { data, error } = await supabase.functions.invoke('myto-cz-browserless', {
      body:normalizedPayload,
    });

    if (error) {
      throw new Error(await functionErrorMessage(error, 'Edge Function MYTO CZ zakończyła się błędem.'));
    }
    if (!data?.ok || !data?.result) {
      throw new Error(data?.error || 'MYTO CZ nie zwróciło wyniku.');
    }

    const result = {
      ...normalizedPayload,
      ...data.result,
      jobId,
      requestId:jobId,
      source:'browserless',
      cloudGuardrail:data.guardrail || null,
    };

    emit({
      source:'D24_BROWSERLESS_CALCULATOR',
      transport:'browserless',
      type:'CALCULATOR_RESULT',
      payload:result,
    });

    return result;
  })()
    .catch(error => {
      emit({
        source:'D24_BROWSERLESS_CALCULATOR',
        transport:'browserless',
        type:'JOB_ERROR',
        payload:normalizedPayload,
        error:error?.message || String(error),
      });
      throw error;
    })
    .finally(() => {
      activeJobs.delete(jobId);
    });

  activeJobs.set(jobId, promise);
  return promise;
}
